export default {
  async getCustomerChannelsByIds(axios, token, ids) {
    return await axios.get(`/api/message/customer-channels/?filter[id]=${ids}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    });
  }
};
